export default __webpack_public_path__ + "static/media/IMG_4649.d89ae59f.JPG";